<template>
  <div class="category-tab-container p-3">
    <a-row :gutter="[16, 16]">
      <a-col span="24">
        <a-typography-title :level="5">Operation Category</a-typography-title>
        <!-- <a-typography-paragraph type="secondary">
          Assigning a category to this operation will create Station level analytics.
        </a-typography-paragraph> -->
      </a-col>
      <a-col :xs="24" :sm="24" :md="12" :lg="8">
        <a-form-item label="Category">
          <a-select
            v-model:value="selectedCategory"
            placeholder="Select a category"
            :options="categoryOptions"
            :loading="isLoadingCategories"
            :disabled="isLoadingCategories"
            allow-clear
            show-search
            :filter-option="filterOption"
            @change="handleCategoryChange"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TaskCategoryService from 'src/services/taskCategory';

export default {
  name: 'CategoryTab',
  inject: ['toast'],
  props: {
    initialCategory: {
      type: [Number, String, null],
      default: null,
    },
  },
  emits: ['category-change'],
  data() {
    return {
      selectedCategory: null,
      categories: [],
      isLoadingCategories: false,
    };
  },
  computed: {
    ...mapGetters(['taskOrganization']),
    categoryOptions() {
      return this.categories.map((cat) => ({
        value: cat.id,
        label: cat.name,
      }));
    },
    organization() {
      return this.taskOrganization || localStorage.getItem('organization');
    },
  },
  watch: {
    initialCategory: {
      immediate: true,
      handler(newVal) {
        this.selectedCategory = newVal;
      },
    },
  },
  mounted() {
    this.fetchCategories();
  },
  methods: {
    filterOption(input, option) {
      return option.label.toLowerCase().includes(input.toLowerCase());
    },
    async fetchCategories() {
      if (!this.organization) {
        return;
      }

      this.isLoadingCategories = true;
      const [error, data] = await TaskCategoryService.getTaskCategories(
        this.organization
      );
      this.isLoadingCategories = false;

      if (error) {
        this.toast.error('Error fetching task categories');
        this.categories = [];
        return;
      }

      this.categories = data || [];
    },
    handleCategoryChange(value) {
      this.$emit('category-change', value || null);
    },
  },
};
</script>

<style scoped>
.category-tab-container {
  min-height: 200px;
}
</style>
